import tags from "../../../components/tags";
import { icons, note } from "../../../components/html";
import { statusCodes } from "../../../components/responses";

export default {
  "/client/size-advisor/{id}": {
    get: {
      tags: [tags.businessAccount],
      summary: "Size advisor based on entered measurements",
      description: `${icons.e}${icons.c}
      Returns size advisor based on entered measurements.
${note(
  "For successful recommendation it is necessary for the client to have the chart added to its active one."
)}`,
      parameters: [
        { $ref: "#/components/parameters/acceptsLanguages" },
        { $ref: "#/components/parameters/tableId" },
        {
          in: "query",
          name: "sizes",
          schema: {
            type: "object",
            properties: {
              a: { type: "string" }
            }
          },
          description:
            "Measure ids and measure values on which the recommendation is based",
          example: { "4": 180, "7": 30 }
        }
      ],

      responses: {
        "200": {
          description: "successful"
        },
        ...statusCodes
      }
    }
  }
};
